import React, { useState, useRef } from "react";
import { Select, Table, Input, Popover, Tooltip } from "antd";
import "./style.scss";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import numeral from "numeral";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getRiscontiList } from "../../../store/actions/accountingYears";
import LoaderSimple from "../../general/loader";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";
import EmptyDashboardData from "../../preCog/toBeAccountantContent/emptyDashboardData";
import { getDraftIdFromOriginalEntry } from "../../../store/actions/precog";

const Option = Select.Option;

const RiscontiModal = ({accountingPeriodId}) => {

  const dispatch = useDispatch();
  const printPDF = useRef();
  const [filteredList , setFilteredList] = useState([]);
  const [filtersTable, setFiltersTable] = useState(null);
  const [csvData, setCsvData ] = useState([]);  
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getRiscontiList(accountingPeriodId));
  }, []);

  const riscontiList = useSelector(state => state?.precog?.accountingYearsRisconti?.data?.deferralList);

  useEffect(() => {    
    setFilteredList(riscontiList);
  }, [riscontiList]);

  useEffect(() => {
    const filterNew = riscontiList?.filter(function(item) {
      for (let key in filtersTable) {                
        if (filtersTable[key] && (item[key] === undefined || !(item[key].toString()).includes(filtersTable[key])))
          return false;
      }
      return true;
    });

    setFilteredList(filterNew);
      
  }, [filtersTable]);

  useEffect(() => {
    const csvDataToExport = filteredList?.map(i => {
      return {
        DataRegistrazione: moment(i.postingDate).format(DATE_FORMAT_FOR_DISPLAY),
        DataDocumento: moment(i.documentDate).format(DATE_FORMAT_FOR_DISPLAY),
        NumDoc: i.documentNumber,
        Causale: i.reason === null ? "/" : i.reason,
        ContoContabile: i.accountDesc,
        Contropartita: i.deferralType === "DEFERRED_EXPENSES" ? "Risconto Passivo" : "Risconto Attivo",
        InizioFineCompetenza: `${moment(i.startEndCompetence[0]).format(DATE_FORMAT_FOR_DISPLAY)} ${moment(i.startEndCompetence[1]).format(DATE_FORMAT_FOR_DISPLAY)}`,
        Importo: `${numeral(i.amount).format("0,0.00")} €`,
        GiorniCompEsercizio: i.accruedDays,
        GiorniCompSuccess: i.days,
        Valore: `${numeral(i.accruedAmount).format("0,0.00")} €`
      };
    });
    setCsvData(csvDataToExport);
  }, [filteredList]);

  const riscontiListStatus = useSelector(state => state?.precog?.accountingYearsRisconti?.status);

  const deferredExpensesTotalAmount = useSelector(state => state?.precog?.accountingYearsRisconti?.data?.deferredExpensesTotalAmount);
  const deferredRevenuesTotalAmount = useSelector(state => state?.precog?.accountingYearsRisconti?.data?.deferredRevenuesTotalAmount);

  const totalContents = [
    {
      title: useIntl().formatMessage({id: "accountingYear.riscontiTitleActive"}),
      amount: <span style={{color: "#152935"}}>{`${numeral(Math.abs(deferredExpensesTotalAmount)).format("0,0.00")} €`}</span>
    }, 
    {
      title: useIntl().formatMessage({id: "accountingYear.riscontiTitlePassive"}),
      amount: <span style={{color: "#005075"}}>{`${numeral(Math.abs(deferredRevenuesTotalAmount)).format("0,0.00")} €`}</span>
    }
  ];

  const isError = riscontiListStatus?.error;
  const isLoading = riscontiListStatus?.started && !riscontiListStatus?.ended;

  const handleChange = (filterKey, value) => {
    setFiltersTable({
      ...filtersTable,
      [filterKey]: value
    });
  };

  const goToDetails = (record) => {
    dispatch(getDraftIdFromOriginalEntry(record.originalEntryId)).then((res) => {
      navigate(`/precog-detail/${res}`, {state: {isFromRisconti: true}});         
    }).catch(err => {

    });
  };
	
  const initial = {
    key: "initial",
    postingDate: "initial",
    documentDate: "initial",
    documentNumber: "initial",
    reason: "initial",
    accountDesc: "initial",
    deferralType: "initial",
    startEndCompetence: "initial",
    amount: "initial",
    accruedDays: "initial",
    days: "initial",
    accruedAmount: "initial"
  };

  const deferralTypes = riscontiList?.map(f => f.deferralType);

  const uniqueDeferralTypes = [...new Set(deferralTypes)];

  const deferralSelectOptions = uniqueDeferralTypes?.map((x, index) => {
    return (
      <Option key={index} value={x}>{x === "DEFERRED_EXPENSES" ? "Risconto Passivo" : "Risconto Attivo"}</Option>
    );
  });

  const downloadPopoverContent = (
    <>
      <ReactToPrint
        trigger={() => (
          <div className="popover-content-row">
            <span className="popover-text">PDF</span>
          </div>
        )}
        content={() => printPDF.current}
      />
      <CSVLink
        data={csvData || []}
        filename={
          "Risconti" + new Date().toDateString().replaceAll(" ", "_") + ".csv"
        }>
        <div className="popover-content-row">
          <span className="popover-text">CSV</span>
        </div>
      </CSVLink>
    </>
  );

  const renderAccruedDaysTitle = () => {
    return (
      <Tooltip title="Giorni di competenza degli esercizio" color="#005075">
        <span>Gg. comp. esercizio </span>
      </Tooltip>
    );
  };

  const renderDaysTitle = () => {
    return (
      <Tooltip title="Giorni di competenza degli esercizi successivi" color="#005075">
        <span>Gg. comp. esercizi succ.</span>
      </Tooltip>
    );
  };
 
  const columns = [
    {
      title: "Data registrazione",
      dataIndex: "postingDate",
      key: "postingDate",
      width: "4%",
      render: value => value === "initial" ? null : moment(value).format(DATE_FORMAT_FOR_DISPLAY)
    },
    {
      title: "Data documento",
      dataIndex: "documentDate",
      key: "documentDate",
      width: "4%",
      render: value => value === "initial" ? null : moment(value).format(DATE_FORMAT_FOR_DISPLAY)
    },
    {
      title: "Numero documento",
      dataIndex: "documentNumber",
      key: "documentNumber",
      width: "4%",
      render: value => value === "initial" ? null : value
    },
    {
      title: "Causale contabile",
      dataIndex: "reason",
      key: "reason",
      width: "9%",
      render: value => value === "initial" ? null : value === null ? "/" : value
    },
    {
      title: "Conto contabile",
      dataIndex: "accountDesc",
      key: "accountDesc",
      width: "10%",
      render: value => (value === "initial" ?
        <Input
          className="input-search transparent"
          allowClear={true}
          suffix={<FontAwesomeIcon
            icon={["far", "search"]}            
          />}          
          placeholder="Cerca"
          onChange={(e) => handleChange("accountDesc", e.target.value)}
        />
        : value
      )
    },
    {
      title: "Contropartita",
      dataIndex: "deferralType",
      key: "deferralType",
      width: "10%",
      render: value => (value === "initial" ?
        <Select
          className="input-search transparent noBorder risconti-modal-select"
          allowClear={true}
          placeholder="Seleziona"
          onChange={(val) => handleChange("deferralType",val)}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {deferralSelectOptions}
        </Select>
        : value === "DEFERRED_EXPENSES" ? "Risconto Attivo" : "Risconto Passivo"
      )
    },
    {
      title: "Inizio/Fine competenza",
      dataIndex: "startEndCompetence",
      key: "startEndCompetence",
      width: "6%",
      render: value => value === "initial" ? null 
        : <div style={{maxWidth: "80px"}}>
          {
            `${moment(value[0]).format(DATE_FORMAT_FOR_DISPLAY)} ${moment(value[1]).format(DATE_FORMAT_FOR_DISPLAY)}`
          }
        </div>
    },
    {
      title: "Importo",
      dataIndex: "amount",
      key: "amount",
      width: "6%",
      render: value => value === "initial" ? null : `${numeral(value).format("0,0.00")} €`
    },
    {
      title: renderAccruedDaysTitle(),
      dataIndex: "accruedDays",
      key: "accruedDays",
      width: "6%",
      render: value => value === "initial" ? null : value   
    },
    {
      title: renderDaysTitle(),
      dataIndex: "days",
      key: "days",
      width: "7%",
      render: value => value === "initial" ? null : value   
    },
    {
      title: "Importo risconto",
      dataIndex: "accruedAmount",
      key: "accruedAmount",
      width: "12%",
      render: (value, record) => value === "initial" ? null : (
        <div style={{display: "flex", alignItems: "center"}}>
          <span style={{marginRight: "120px"}}>{`${numeral(value).format("0,0.00")} €`}</span>
          <FontAwesomeIcon style={{color: "#0090d1", cursor: "pointer"}} 
            icon={["far", "arrow-right"]} onClick={() => {            
              goToDetails(record);            
            }
            } />
        </div>
      )
    }
  ];

  return (
    <div ref={printPDF}>
      <div className="risconti-modal-container">
        <div className="risconti-modal-header">
          <div className="sub-content left">
            {totalContents.map((c, index) => {
              return (
                <div key={index} className="total-container">
                  <h6 className="total-title"> {c.title}</h6>
                  <span className="total-amount">{c.amount}</span>
                </div>
              );
            })
            }
          </div>
          <div className="sub-content right">
            <Popover 
              placement="bottom" 
              trigger="hover" 
              content={downloadPopoverContent}
              getPopupContainer={trigger => trigger.parentNode}
              zIndex={1000000}
              overlayClassName={"download-popover-content"}
            >
              <FontAwesomeIcon
                icon={["far", "download"]}
                style={{
                  color: "#0090d1",
                  cursor: "pointer"
                }}
              />
            </Popover>
          </div>
        </div>
        {!isLoading && !isError && filteredList !== undefined && filteredList?.length > 0 ?
          <Table
            className="vaporTable yearsOperationsTable" 
            columns={columns}
            dataSource={[initial, ...filteredList]}    
            pagination={false}      
          />
          : isError ? <EmptyDashboardData>
            <>
              <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_error" /></p>
            </>
          </EmptyDashboardData>  
            : !isLoading && !isError && !filteredList?.length > 0 ? 
              <EmptyDashboardData>
                <>
                  <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_deferrals" /></p>
                </>
              </EmptyDashboardData>  
              : <LoaderSimple /> 
        } 
      </div>
    </div>
  );
};

export default RiscontiModal;
